import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './Visibility.css';

export interface Props extends FlexProps {
  /**
   * Flag that makes the component work independently from
   * the container, and controls the visibility.
   */
  visible?: boolean;
}

/**
 * A component to fade content in when the child component
 * is hovered on, or can be used standalone as a controlled component with the
 * visibility prop.
 */
const Visibility: React.FunctionComponent<Props> = (props: Props) => {
  const { visible, ...rest } = props;
  const classes = classnames('Visibility', {
    'Visibility--uncontrolled': visible === undefined,
    'Visibility--visible': visible,
  });

  return (
    <Flex className={ classes } { ...rest } />
  );
};

export default Visibility;
